

import { BsLink45Deg } from '@react-icons/all-files/bs/BsLink45Deg'
import { FcCalendar } from '@react-icons/all-files/fc/FcCalendar'
import { Btn, Card, Ellipsis } from 'mga-commons'
import React, { Suspense, useRef } from 'react'
import { toastr } from 'react-redux-toastr'
import { useNavigate } from 'react-router-dom'
import ImagesFiche from '../../components/anonymous/fiche/ImagesFiche'

import NotifInfo from '../../components/commons/notifs/NotifInfo/NotifInfo'
import { EnumProfil, EnumTypeContact, EnumTypeFiche } from '../../utils/EnumApp'
import { getUrlFromIdTypeFiche } from '../../utils/StringUtils'
import './PageFicheConsultationMobile.css'

const InfosRdvs = React.lazy(() => import('../../components/anonymous/fiche/InfosRdvs'))
const MapLocation = React.lazy(() => import('../../components/commons/MapLocation'))


const contactsEntries = Object.values(EnumTypeContact)

const PageFicheConsultationMobile = ({ item, userProfile }) => {

    const rdvBloc = useRef(null)
    const navigate = useNavigate()

    const handleSmoothScrol = () => {
        rdvBloc?.current?.scrollIntoView({
            behavior: "smooth"
        })
    }

    const handleSubscribe = () => {

        const toastrConfirmOptions = {
            transitionIn: 'bounceInDown',
            okText: 'Valider',
            cancelText: 'Annuler',
            component: () => <NotifInfo title="Connexion ?" message={`Connectez-vous pour prendre rendez-vous`} />,
            onOk: () => {
                navigate('/connexion?from=' + window.location.pathname)
            }
        }
        toastr.confirm(null, toastrConfirmOptions)
    }

    const renderRdvs = () => {

        if (item.EstUtilisateur) {

            if (!item.EstActifRdv) {
                return (
                    <div className="subscribe-message">
                        Les rendez-vous sont <strong style={{ color: 'red' }}>indisponibles</strong>.
                        <br />
                        Veuillez contacter votre praticien directement.
                    </div>
                )
            }


            if (!userProfile || userProfile.Profil !== EnumProfil.Patient.value) {
                return (
                    <div className="subscribe-message">
                        <strong>Pour prendre rendez-vous, connectez-vous </strong>
                        <Btn margin="30px 10px 0 10px" onClick={handleSubscribe}>
                            <strong>Se connecter</strong>
                        </Btn>
                    </div>
                )
            }

            return (
                <>
                    <div className="rdv-title">
                        Réserver votre rendez-vous
                    </div>
                    <Suspense fallback="">
                        <InfosRdvs item={item} />
                    </Suspense>q
                </>
            )
        }

        // Pas utilisateur
        return (
            <div className="subscribe-message">
                C'est votre établissement ? <span className="subscribe-link" onClick={() => navigate('/inscription-pro?from=' + window.location.pathname)}>Inscrivez-vous ici ! </span>
            </div>
        )
    }

    const renderSpecialites = () => {
        if (item.Specialites == null || item.Specialites.length < 1) {
            return null
        }

        return (
            <>
                <div className="bloc-title">Spécialités</div>
                <ul className="specialite-list">
                    {item.Specialites.map((item, index) => <li key={index}>{item}</li>)}
                </ul>
            </>
        )
    }

    const renderLink = (paramItem, paramIndex) => {

        // Email
        if (paramItem.IdTypeContact === EnumTypeContact.Email.value) {

            let numFormatted = 'mailto:' + paramItem.Valeur

            return (
                <li key={paramIndex}>
                    <span>{contactsEntries.find(x => x.value.toString() === paramItem.IdTypeContact.toString())?.label}</span>
                    <a className="txt-contact" target="_blank" rel="noopener noreferrer" href={numFormatted}>&nbsp;:&nbsp;{paramItem.Valeur}</a>
                </li>
            )
        }

        // Tel
        let numFormatted = 'tel:' + paramItem.Valeur

        return (
            <li key={paramIndex}>
                <span>{contactsEntries.find(x => x.value.toString() === paramItem.IdTypeContact.toString())?.label}</span>
                <a target="_blank" href={numFormatted} rel="noreferrer">&nbsp;:&nbsp;{paramItem.Valeur}</a>
            </li>
        )
    }

    const renderContacts = () => {

        if (item.Contacts == null || item.Contacts.length < 1) {
            return null
        }

        return (
            <>
                <div className="bloc-title">Coordonnées</div>
                <ul className="contact-list">
                    {item.Contacts.map(renderLink)}
                </ul>
            </>

        )
    }

    const renderInfosAcces = () => {
        if (item.InfosAcces != null) {
            return (
                <>
                    <div className="bloc-title">Accès</div>
                    <div className="bloc-acces">
                        {item.InfosAcces}
                    </div>
                </>
            )
        }

        return null
    }

    const renderAdresse = () => {

        return (
            <>
                <div className="bloc-title">Adresse</div>
                <div className="bloc-adresse">
                    {item.Ligne1 != null ? <div>{item.Ligne1}</div> : null}
                    {item.Ligne2 != null ? <div>{item.Ligne2}</div> : null}
                    <div>
                        {item.CodePostal == null ? '' : item.CodePostal + ' '}
                        {item.Ville == null ? '' : item.Ville}
                        {item.Wilaya == null ? '' : ' - ' + item.Wilaya}
                    </div>
                </div>
            </>
        )
    }

    const renderFormations = () => {

        if (!item.Formations || item.IdTypeFiche !== EnumTypeFiche.Medecin.Value) {
            return null
        }

        return (
            <>
                <div className="bloc-title">Formation & Parcours professionnel</div>
                <div className="bloc-formations">{item.Formations}</div>
            </>
        )
    }

    const renderInfosUtiles = () => {

        if (!item.InfosUtiles) {
            return null
        }

        return (
            <>
                <div className="bloc-title">Infos utiles</div>
                <div className="bloc-infos-utiles">{item.InfosUtiles}</div>
            </>
        )
    }

    const urlTypeEntite = getUrlFromIdTypeFiche(item.IdTypeFiche, item.IdTypeMedecin, item.IdTypeEtablissement, item.IdTypeService)

    const canSeeAdresse = item.Ligne1
        || item.Ligne2
        || item.CodePostal
        || item.Ville
        || item.Wilaya
        || item.InfosAcces

    const canSeeInfosUtiles = item.InfosUtiles
        || (item.Formations && item.IdTypeFiche === EnumTypeFiche.Medecin.Value)

    return (
        <div className="page-fiche-consultation-mobile">
            <Card margin="20px 0 20px 0" className="infos">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <ImagesFiche item={item} />
                    <h1 className="fiche-libelle">Dr. {item.LibelleAffichage}</h1>
                    <div>
                        {item.EstActifRdv &&
                            (
                                <Btn onClick={handleSmoothScrol} margin="20px auto" maxWidth="350px">
                                    <FcCalendar size="32" />
                                    &nbsp;&nbsp;
                                    <strong>Prendre un rendez-vous</strong>
                                </Btn>
                            )
                        }
                    </div>
                    <a className="specialite-sub-title" href={urlTypeEntite} title={'Spécialité ' + item.LibelleTypeEntite}>
                        <h2><BsLink45Deg /><Ellipsis>{item.LibelleTypeEntite}</Ellipsis></h2>
                    </a>
                </div>
            </Card>
            <Card margin="40px 0 20px 0" className="contacts">
                {renderSpecialites()}
                {renderContacts()}
            </Card>
            <Card margin="40px 0 20px 0" className="rdvs">
                <span id="rdvs-bloc" ref={rdvBloc}></span>
                {renderRdvs()}
            </Card>
            {
                canSeeAdresse
                && <Card margin="40px 0 20px 0" className="acces">
                    {renderAdresse()}
                    {renderInfosAcces()}
                    {item
                        && item.Latitude
                        && item.Longitude
                        && <MapLocation item={item} />
                    }
                </Card>
            }
            {
                canSeeInfosUtiles
                && <Card margin="40px 0 20px 0" className="formation">
                    {renderFormations()}
                    {renderInfosUtiles()}
                </Card>
            }
            <br />
            <br />
            <br />
        </div >
    )
}

export default PageFicheConsultationMobile
